import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />;

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Overview',
    items: [
      { title: 'Dashboard', path: paths.dashboard.root, icon: ICONS.course, roles: ['admin'] },
      {
        title: 'Reports',
        path: paths.dashboard.reports.root,
        icon: ICONS.file,
        roles: ['customer', 'analyst', 'admin', 'member'],
      },
      {
        title: 'Groups',
        path: paths.dashboard.groups.root,
        icon: ICONS.folder,
        roles: ['customer', 'member'],
      },
    ],
  },
  /**
   * Management
   */
  {
    subheader: 'Management',
    roles: ['admin'],
    items: [
      {
        title: 'User Management',
        path: paths.dashboard.management.root,
        icon: ICONS.user,
        roles: ['admin'],
      },
      {
        title: 'Logs',
        path: paths.dashboard.logs,
        icon: ICONS.menuItem,
        roles: ['admin'],
      },
      {
        title: 'Configuration',
        path: paths.dashboard.test.root,
        icon: ICONS.parameter,
        roles: ['admin'],
        children: [
          { title: 'Tier 1 - Company', path: paths.dashboard.test.company },
          { title: 'Tier 1 - Individual', path: paths.dashboard.test.individual },
          { title: 'Screening', path: paths.dashboard.test.screening },
        ],
      },
    ],
  },
];
